var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block px-4 py-1 rounded-full font-semibold",class:_vm.statusClass,domProps:{"innerHTML":_vm._s(_vm.statusText)}})}
var staticRenderFns = []

export { render, staticRenderFns }